import type { SVGProps } from 'react'

export const CheckVerifiedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    focusable={false}
    {...props}
  >
    <g fill="currentColor" clipPath="url(#check-verified_svg__a)">
      <path d="M16.207 10.207a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z" />
      <path
        fillRule="evenodd"
        d="M15.024 2.333c-1.519-2.003-4.53-2.003-6.048 0a1.795 1.795 0 0 1-1.674.693c-2.49-.342-4.618 1.787-4.276 4.276a1.795 1.795 0 0 1-.694 1.675c-2.002 1.518-2.002 4.528 0 6.047.517.392.782 1.032.694 1.674-.342 2.49 1.786 4.618 4.276 4.276a1.794 1.794 0 0 1 1.674.694c1.519 2.002 4.53 2.002 6.047 0a1.794 1.794 0 0 1 1.675-.694c2.49.342 4.618-1.786 4.276-4.276a1.795 1.795 0 0 1 .693-1.674c2.003-1.519 2.003-4.529 0-6.047a1.795 1.795 0 0 1-.693-1.675c.342-2.49-1.787-4.618-4.276-4.276a1.795 1.795 0 0 1-1.675-.693ZM10.57 3.54a1.795 1.795 0 0 1 2.86 0 3.794 3.794 0 0 0 3.54 1.467 1.794 1.794 0 0 1 2.023 2.022 3.795 3.795 0 0 0 1.466 3.54 1.794 1.794 0 0 1 0 2.86 3.795 3.795 0 0 0-1.466 3.54 1.794 1.794 0 0 1-2.023 2.023 3.794 3.794 0 0 0-3.54 1.466 1.795 1.795 0 0 1-2.86 0 3.794 3.794 0 0 0-3.54-1.466 1.794 1.794 0 0 1-2.023-2.022 3.795 3.795 0 0 0-1.466-3.54 1.794 1.794 0 0 1 0-2.86A3.795 3.795 0 0 0 5.007 7.03 1.795 1.795 0 0 1 7.03 5.008a3.794 3.794 0 0 0 3.54-1.467Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="check-verified_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
